import React from 'react'
import Style from '../IncidentFeed.module.css'
import { LOAD_ERROR, NOT_COMPUTED_TITLE } from '../messages'

// ===========================================================================
// Threat Feed status tiles (PIXMC-6500).
//
// The three counts come from the SAME payload the Overview ring uses
// (dashboard/stats/{id}/overview/phishing-detections) — fetched by IncidentFeed.jsx for
// this tab. Labels and precedence match RING_SEGMENTS in PhishingDetectionsRing.jsx
// (PIXM Verified → Verified Phish → AI Suspicious).
//
// D-7 discriminator, same as the ring: branch on `available`, never on the counts (0 is
// falsy). `available` is three-valued — null = not asked yet, false = asked/no rows,
// true = counts present. A failed load and a never-computed customer read differently, and
// NEITHER ever renders the API's own error text (messages.js owns the fixed strings).
// ===========================================================================

export const TILES = [
  { key: 'pixmVerified', label: 'PIXM Verified', note: 'Confirmed by the PIXM engine' },
  { key: 'verifiedPhish', label: 'Verified Phish', note: 'Matched known phishing sites' },
  { key: 'aiSuspicious', label: 'AI Suspicious', note: 'Flagged by AI, pending verification' },
]

const formatCount = (n) => (typeof n === 'number' ? n.toLocaleString() : '—')

const ThreatStatusTiles = ({ overview, loading, error }) => {
  const available = overview ? overview.available : null
  const pending = available === null
  const hasData = !loading && available === true
  // The fetch has finished (not loading, and we are past the initial not-asked-yet state).
  const settled = !loading && !pending

  return (
    <div className={Style.tileRow}>
      {TILES.map((tile) => {
        const value = hasData ? formatCount(overview[tile.key]) : '—'
        const note = hasData
          ? tile.note
          : settled
            ? error ? LOAD_ERROR : NOT_COMPUTED_TITLE
            : tile.note
        return (
          <div className={Style.tile} key={tile.key}>
            <div className={Style.tileLabel}>{tile.label}</div>
            <div className={Style.tileValue} data-testid={`tile-${tile.key}`}>{value}</div>
            <div className={Style.tileNote}>{note}</div>
          </div>
        )
      })}
    </div>
  )
}

export default ThreatStatusTiles
